import React from 'react'
import { useTranslation } from 'react-i18next'

export const Footer: React.FC = () => {
    const { t } = useTranslation()
    return (
        <footer className="site-footer">
            <div className="footer-container">
                <div className="row">
                    <div className="columns medium-12">
                        <ul className="medium-block-grid-5 small-block-grid-2">
                            <li>
                                <h3>{t('DESTINATIONS')}</h3>
                                <ul className="footer-links">
                                    <li><a href="/">{t('Europe')}</a></li>
                                    <li><a href="/">{t('Asia')}</a></li>
                                    <li><a href="/">{t('North America')}</a></li>
                                    <li><a href="/">{t('South America')}</a></li>
                                    <li><a href="/">{t('Africa')}</a></li>
                                    <li><a href="/">{t('Australia')}</a></li>
                                </ul>
                            </li>
                            <li>
                                <h3>{t('BOOKING')}</h3>
                                <ul className="footer-links">
                                    <li><a href="/">{t('Activities And Tours')}</a></li>
                                    <li><a href="/">{t('Activities For Different Area')}</a></li>
                                    <li><a href="/">{t('Vacation Rental')}</a></li>
                                    <li><a href="/">{t('Car Rental')}</a></li>
                                    <li><a href="/">{t('Hotels')}</a></li>
                                    <li><a href="/">{t('Golf Courses')}</a></li>
                                </ul>
                            </li>
                            <li>
                                <h3>{t('USEFUL LINKS')}</h3>
                                <ul className="footer-links">
                                    <li><a href="/">{t('Testimonials')}</a></li>
                                    <li><a href="/">{t('360tourist-career')}</a></li>
                                    <li><a href="/">{t('360° Virtual-tour Services')}</a></li>
                                    <li><a href="/">{t('Rates Virtual Tours')}</a></li>
                                </ul>
                            </li>
                            <li>
                                <h3>{t('MORE')}</h3>
                                <ul className="footer-links">
                                    <li><a href="/">{t('Contact Us')}</a></li>
                                    <li><a href="/">{t('About Us')}</a></li>
                                    <li><a href="/">{t('Blog')}</a></li>
                                </ul>
                            </li>
                            <li>
                                <h3>{t('HIGHLIGHTS')}</h3>
                                <ul className="footer-links">
                                    <li><a href="/">{t('360 Luxury Villa Rentals')}</a></li>
                                    <li><a href="/">{t('360 Luxury Estates')}</a></li>
                                    <li><a href="/">{t('Las Terrenas')}</a></li>
                                    <li><a href="/">{t('360 Real Estate')}</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="columns medium-12">
                        <div className="copyright">
                            <div className="row">
                                <div className="columns medium-9">
                                    <p>{t('Copyright Notice')}</p>
                                </div>
                                <div className="columns medium-3 text-right">
                                    <a href="/" target="_blank"><img src="/images/icons/facebook.png" alt="facebook" /></a>
                                    <a href="/" target="_blank"><img src="/images/icons/twitter.png" alt="twitter" /></a>
                                    <a href="/" target="_blank"><img src="/images/icons/instagram.png" alt="instagram" /></a>
                                    <a href="/" target="_blank"><img src="/images/icons/google-plus.png" alt="google-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}